import api from "../api/axios";
import { PedidoDefensa } from "../types/defensa";
import { InstanciaPaso } from "../types/instanciaPaso";

export interface RevisionDefensa {
  proceso: InstanciaPaso;
  /** La reserva tal como la tiene SAR, o null si allá no existe. */
  en_sar: { sala: { nombre: string }; inicio: string; termino: string } | null;
  error_sar: string | null;
  motivo_no_agendable: string | null;
}

export const defensaService = {
  /** Vuelve a leer la reserva en SAR y alinea lo guardado. */
  revisar: async (id: number): Promise<RevisionDefensa> => {
    const { data } = await api.get<RevisionDefensa>(`instancias/${id}/defensa/`);
    return data;
  },

  /** Agenda, mueve o actualiza. Un 409 trae `sin_sala`; un 422, `errores`. */
  agendar: async (id: number, pedido: PedidoDefensa): Promise<{ resultado: string; proceso: InstanciaPaso }> => {
    const { data } = await api.put(`instancias/${id}/defensa/`, pedido);
    return data;
  },

  /** El enlace firmado para que el estudiante cree la agenda de su examen en Miti. */
  enlaceMiti: async (id: number): Promise<string> => {
    const { data } = await api.get<{ url: string }>(`instancias/${id}/coordinacion/miti/`);
    return data.url;
  },

  /** Vuelve a leer Miti y, si ya está todo acordado (y presencial), agenda en SAR. */
  sincronizarMiti: async (id: number): Promise<InstanciaPaso> => {
    const { data } = await api.post<InstanciaPaso>(`instancias/${id}/coordinacion/miti/`);
    return data;
  },

  /** El correo de un integrante que no tenía; con la agenda abierta, se le invita al tiro. */
  ingresarCorreo: async (id: number, clave: string, email: string): Promise<InstanciaPaso> => {
    const { data } = await api.post<InstanciaPaso>(`instancias/${id}/coordinacion/correo/`, { clave, email });
    return data;
  },

  /** Sube la carta **firmada** de la modalidad remota de un participante (queda pendiente de
   * aprobación) y devuelve el proceso refrescado. */
  subirCartaRemota: async (id: number, clave: string, archivo: File): Promise<{ proceso: InstanciaPaso }> => {
    const fd = new FormData();
    fd.append("clave", clave);
    fd.append("archivo", archivo);
    const { data } = await api.post(`instancias/${id}/coordinacion/carta-remota/`, fd);
    return data;
  },

  /** La coordinación aprueba la carta firmada de un participante remoto; devuelve el proceso. */
  aprobarCartaRemota: async (id: number, clave: string): Promise<{ proceso: InstanciaPaso }> => {
    const { data } = await api.post(`instancias/${id}/coordinacion/carta-remota/aprobar/`, { clave });
    return data;
  },

  /** URL para descargar la carta **firmada** vigente de un participante (se abre en otra pestaña,
   * con la sesión; nadie sirve `/media/` directo). */
  urlCartaFirmada: (id: number, clave: string): string =>
    `${api.defaults.baseURL}instancias/${id}/coordinacion/carta-remota/?clave=${encodeURIComponent(clave)}`,

  /** URL para descargar la **plantilla** (carta tipo) del rol de un participante. */
  urlPlantillaCarta: (id: number, clave: string): string =>
    `${api.defaults.baseURL}instancias/${id}/coordinacion/carta-remota/plantilla/?clave=${encodeURIComponent(clave)}`,

  cancelar: async (id: number, motivo: string): Promise<{ resultado: string; proceso: InstanciaPaso }> => {
    const { data } = await api.delete(`instancias/${id}/defensa/`, { data: { motivo } });
    return data;
  },
};
